import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
// eslint-disable-next-line no-unused-vars
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import styles from '../IMSLDAPValidator.module.scss'

export const InfoDialog = ({
	open = false,
	options = [],
	onChange = () => { },
	onClose = () => { },
	value = null,
}) => {
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle className={styles.dialogTitle}><strong>IMS LDAP Validator Information</strong></DialogTitle>
			<DialogContent>
			<ul>
				<li>Employees and contingent workers should be in the PSFT and InfNet OU (non-employees only appear in Infnet)</li>
				<li>User must be registered in HRDirect (MyHub) to be in locations marked with an *</li>
			</ul>
			<p><strong>Corrective steps for registered users if all indicators are green:</strong></p>
			<ul>
				<li>Wait 5 minutes, try again</li>
				<li>Do a Forgot Password or Change Password . Wait 5 minutes, try again.</li>
				<li>Reset registration and Re-register. Wait 5 minutes, try again.</li>
				<li>Contact IMS Team</li>
			</ul>
			<p><strong>If all are green except HRDirect (MyHub) OID, contact HR Peoplesoft.</strong></p>
			<p><strong>For users with problems registering:</strong></p>
			<ul>
				<li>If HR data in IMS is green, contact HRIS.</li>
				<li>If HR data in IMS is red, contact the IMS team.</li>
			</ul>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};